import styles from "styles/components/pageWrapper.module.scss";

const PageWrapper = ({ children, width = 1140, style = {} }) => (
  <div className={styles.wrapper} style={{ width: `${width}px`, ...style }}>
    <div className={styles.inner}>{children}</div>
  </div>
);

export default PageWrapper;
